export default __webpack_public_path__ + "817c5ffcca0c718dc5f4f543f1b18413.png";